(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nb-collection-reviews"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nb-collection-review-videos')){
customElements.define('nb-collection-review-videos',class extends HTMLElement{
connectedCallback(){
this.track=this.querySelector('.nb-review-videos__track');
this.previous=this.querySelector('[data-review-step="-1"]');
this.next=this.querySelector('[data-review-step="1"]');
const videos=Array.from(this.querySelectorAll('video'));
const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.onClick=event=>{
const step=event.target.closest('[data-review-step]');
if(step){const card=this.track.querySelector('.nb-review-videos__card');if(card)this.track.scrollBy({left:Number(step.dataset.reviewStep)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:reducedMotion?'instant':'smooth'});return;}
const selected=event.target.closest('.nb-review-videos__card')?.querySelector('video');
if(selected&&selected.muted){
videos.forEach(video=>{if(video!==selected)video.muted=true;});
selected.muted=false;selected.volume=1;selected.play().catch(()=>{});
}
};
this.onScroll=()=>{this.previous.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;};
this.addEventListener('click',this.onClick);
this.onKeydown=event=>{if((event.key==='Enter'||event.key===' ')&&event.target.tagName==='VIDEO'&&event.target.muted){event.preventDefault();this.onClick(event);}};
this.addEventListener('keydown',this.onKeydown);
this.track.addEventListener('scroll',this.onScroll,{passive:true});
videos.forEach(video=>{
const card=video.closest('.nb-review-videos__card');
video.muted=true;video.defaultMuted=true;
video.addEventListener('playing',()=>card.setAttribute('data-playing',''));
video.addEventListener('volumechange',()=>{
card.toggleAttribute('data-sound',!video.muted&&video.volume>0);
if(!video.muted&&video.volume>0)videos.forEach(other=>{if(other!==video)other.muted=true;});
});
});
this.visibilityObserver=new IntersectionObserver(entries=>{
entries.forEach(entry=>{
const video=entry.target;
if(entry.isIntersecting&&!reducedMotion){video.play().catch(()=>{});}
else{video.pause();video.muted=true;}
});
},{threshold:0.35});
videos.forEach(video=>{if(reducedMotion)video.autoplay=false;this.visibilityObserver.observe(video);});
this.observer=new ResizeObserver(this.onScroll);this.observer.observe(this.track);this.onScroll();
}
disconnectedCallback(){this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKeydown);this.track?.removeEventListener('scroll',this.onScroll);this.observer?.disconnect();this.visibilityObserver?.disconnect();this.querySelectorAll('video').forEach(video=>video.pause());}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nb-pdp-trust"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nb-product-trust')){
  customElements.define('nb-product-trust',class extends HTMLElement{
    connectedCallback(){
      this.clock=this.querySelector('[data-nb-daily-clock]');
      if(!this.clock)return;
      this.formatter=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      this.tick();this.timer=setInterval(()=>this.tick(),1000);
    }
    parts(time){return Object.fromEntries(this.formatter.formatToParts(new Date(time)).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));}
    tick(){
      const now=Date.now(),p=this.parts(now),key=p.year+'-'+p.month+'-'+p.day;
      if(this.day!==key){
        const localMidnight=Date.UTC(p.year,p.month-1,p.day+1);let estimate=localMidnight;
        for(let i=0;i<3;i++){const c=this.parts(estimate);const offset=Date.UTC(c.year,c.month-1,c.day,c.hour,c.minute,c.second)-estimate;estimate=localMidnight-offset;}
        this.end=estimate;this.day=key;
      }
      const seconds=Math.max(0,Math.ceil((this.end-now)/1000));
      const h=Math.floor(seconds/3600),m=Math.floor(seconds%3600/60),s=seconds%60;
      this.clock.textContent=[h,m,s].map(n=>String(n).padStart(2,'0')).map((n,i)=>n+' '+['h','m','s'][i]).join(' ');
      this.querySelector('[data-nb-daily]').hidden=false;
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
}
  } catch(e) { console.error(e); }
})();

})();
